














import { mixins } from "vue-class-component";
import { Component, Vue } from "vue-property-decorator";
import { NavBar, Cell, CellGroup, Button } from "vant";
import DemoBlock from "@/components/DemoBlock.vue";
import DemoSection from "@/components/DemoSection.vue";
import WeMixin from "@/components/weMixin";
import Jssdk, { WxJsapiSignature } from "@/components/wechat/wechatJssdkMixin";

@Component({
  components: {
    [NavBar.name]: NavBar,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Button.name]: Button,
    DemoBlock,
    DemoSection,
  },
})
export default class DemoSharePage extends mixins(WeMixin, Jssdk) {
  protected created() {
    this.initWx().then((wjs: WxJsapiSignature) => {
      this.$wx.config({
        debug: wjs.debug, // wjs.debug, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: wjs.appId, // 必填，公众号的唯一标识
        timestamp: wjs.timestamp, // 必填，生成签名的时间戳
        nonceStr: wjs.nonceStr, // 必填，生成签名的随机串
        signature: wjs.signature, // 必填，签名
        jsApiList: ["openLocation"], // 必填，需要使用的JS接口列表
      });
    });
  }

  protected doScan() {
    const lat = 31.51181;
    const lng = 119.97573;
    const address = "宜兴市南漕申兴西路18号";

    if (lat == 31.51181) {
      this.$toast(
        "纬度:" +
          31.51181 +
          ", 经度:" +
          119.97573 +
          ", 详情地址信息:" +
          "宜兴市南漕申兴西路18号"
      );
      return;
    }

    if (!this.$wxReady) {
      return;
    }
    this.$wx.openLocation({
      latitude: lat,
      longitude: lng,
      name: address,
      scale: 28,
    });
  }
}
